module.exports = __webpack_public_path__ + "img/fi.01e0bc8f.svg";